import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-content__img" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div id=\"loading-content__txt\"><div class=\"loading-content__txt__item loading-content__txt__item--1\"> L </div><div class=\"loading-content__txt__item loading-content__txt__item--2\"> o </div><div class=\"loading-content__txt__item loading-content__txt__item--3\"> a </div><div class=\"loading-content__txt__item loading-content__txt__item--4\"> d </div><div class=\"loading-content__txt__item loading-content__txt__item--5\"> i </div><div class=\"loading-content__txt__item loading-content__txt__item--6\"> n </div><div class=\"loading-content__txt__item loading-content__txt__item--7\"> g </div><div class=\"loading-content__txt__item loading-content__txt__item--8\"> . </div><div class=\"loading-content__txt__item loading-content__txt__item--9\"> . </div><div class=\"loading-content__txt__item loading-content__txt__item--10\"> . </div></div>", 1)

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import image from "@/../public/icon/index/img-loading.svg";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'loading-content',
  props: {
    modifires: { type: [String, Array, Boolean] }
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('loading-content', _ctx.modifires))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(image),
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _hoisted_3
  ], 2))
}
}

})